import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-modal-attention-retirement',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-attention-retirement.component.html',
  styleUrls: ['./modal-attention-retirement.component.scss'],
})
export class ModalAttentionRetirementComponent {
  @Input() open = false;

  @Output() closed = new EventEmitter<void>();

  onConfirm(): void {
    this.closed.emit();
  }

  onModalDismiss(): void {
    this.closed.emit();
  }
}
